import {Document, Image, Page, StyleSheet, Text, View} from '@react-pdf/renderer'
import {InvoiceHeaderFooter, IVoucherDetailsResponse} from './_model'
import {parseJSON} from '../../../utils/helperFunction/obj.helper'

type Props = {
  voucherResponse: IVoucherDetailsResponse | undefined
  logo: string
}

const styles = StyleSheet.create({
  page: {padding: 50, fontSize: 14},
  title: {fontSize: 12, fontWeight: 600, marginBottom: 6},
  rowCol: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footer: {
    marginTop: 140,
  },
})

const VoucherPreviewContent = ({voucherResponse, logo}: Props) => {
  if (!voucherResponse) return <></>

  const fromBillMap = Object.fromEntries(
    voucherResponse.fromBillDetails
      .filter((item) => item.optionsValue)
      .map((item) => [item.optionsName, item.optionsValue])
  )

  const invoiceHeaderFooter = parseJSON<InvoiceHeaderFooter>(fromBillMap.invoice_header_footer)

  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <Image
          src={logo}
          style={{
            width: 155, // desired width in PDF units
            height: 50, // desired height
            objectFit: 'contain',
          }}
        />

        <View style={{marginTop: 15, marginBottom: 26}}>
          <Text>Company Name: {invoiceHeaderFooter?.invoice_header.company_name}</Text>
          <Text>Address: {invoiceHeaderFooter?.invoice_header.address}</Text>
          <Text>TIN No: {invoiceHeaderFooter?.invoice_header.tin_no}</Text>
          <Text>BIN No: {invoiceHeaderFooter?.invoice_header.bin_no}</Text>
        </View>

        <View style={styles.rowCol}>
          <View>
            <Text style={{...styles.title}}>Invoice Information</Text>

            <View>
              <Text>Invoice No: {voucherResponse?.invoiceInfo.invoice_no}</Text>
              <Text>Status: {voucherResponse?.invoiceInfo.invoice_status}</Text>
              <Text>Total Cost: {voucherResponse?.invoiceInfo.total_cost}</Text>
              <Text>Due: {voucherResponse?.invoiceInfo.due}</Text>
              <Text>
                Date: {voucherResponse?.invoiceInfo.start_date} to{' '}
                {voucherResponse?.invoiceInfo.end_date}
              </Text>
            </View>
          </View>

          <View>
            <Text style={styles.title}>Voucher Information</Text>

            <View>
              <Text>Voucher No: {voucherResponse?.voucherInfo.voucher_no}</Text>
              <Text>Amount: {voucherResponse?.voucherInfo.voucher_no}</Text>
              <Text>Due: {voucherResponse?.invoiceInfo.due}</Text>
            </View>
          </View>
        </View>

        <Text style={{...styles.title, marginTop: 50}}>Billed To</Text>

        <View>
          <Text>Name: {voucherResponse?.toBillDetails.user_full_name}</Text>
          <Text>Phone: {voucherResponse?.toBillDetails.user_mobile}</Text>
          <Text>Email: {voucherResponse?.toBillDetails.user_email}</Text>
        </View>

        {/* FOOTER */}
        <View style={styles.footer}>
          <View style={{width: '70%'}}>
            <Text>
              Account Name: {invoiceHeaderFooter?.invoice_footer.section_two.account_name}
            </Text>
            <Text>
              Account Number: {invoiceHeaderFooter?.invoice_footer.section_two.account_number}
            </Text>
            <Text>Bank Name: {invoiceHeaderFooter?.invoice_footer.section_two.bank_name}</Text>
            <Text>Branch Name: {invoiceHeaderFooter?.invoice_footer.section_two.branch_name}</Text>
            <Text>Address: {invoiceHeaderFooter?.invoice_footer.section_two.bank_address}</Text>
          </View>

          <View
            style={{
              marginTop: 40,
              paddingTop: '20',
              borderTop: '1px solid black',
            }}
          >
            <Text>{invoiceHeaderFooter?.invoice_footer.contact}</Text>
            <Text>{invoiceHeaderFooter?.invoice_footer.email}</Text>
            <Text>{invoiceHeaderFooter?.invoice_footer.section_one}</Text>
          </View>
        </View>
      </Page>
    </Document>
  )
}

export default VoucherPreviewContent
